export type ViewMode = "grid" | "list";

export const VIEW_MODE = {
  GRID: "grid" as ViewMode,
  LIST: "list" as ViewMode,
} as const;
